(function (ws, win) {
    'use strict';

    ws.views.simpleTable = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_PACKING_SLIP_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION_PACKING_SLIP: 'packing_slip',
        GTM_EVENT_ACTION_PACKING_SLIP_LABEL: 'view_packing_slip',
        GTM_EVENT_CARRIER_TRACKING_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION_CARRIER_TRACKING: 'carrier tracking',
        GTM_EVENT_ACTION_PDF_CARRIER_TRACKING: 'proof_of_delivery_pdf',
        GTM_EVENT_ACTION_SEARCH_RESELLERS: 'manual_order_search_resellers',
        GTM_EVENT_ACTION_SELECT_SALES_ORG: 'manual_order_select_sales_org',
        GTM_EVENT_ACTION_SELECT_ACC_NUMBER: 'manual_order_select_account_ number',
        GTM_EVENT_ACTION_SELECT_CURRENCY: 'manual_order_select_currency',

        //object to map GTM event labels with filter options
        gtmFilterOptions: {
            //order filters
            code: 'Order No.',
            partNumber: 'Part No.',
            purchaseOrderNumber: 'Customer Purchase Order No.',
            sapOrderId: 'Westcon Sales Order No.',
            invoiceNumber: 'Invoice No.',
            confirmationNumber: 'Confirmation No.',
            endCustomer: 'End User Customer Name',
            shipToCustName: 'Ship To Customer Name',
            serialNumber: 'Serial No.',
            projectNumber: 'Project No.',
            authorizationNumber: 'Authorization No.',
            contractNumber: 'Contract No.',
            westconGroupPurchaseOrderNumber: 'Westcon Group P.P. No. to Manufacturer',

            //quote filters
            firstname: 'End User',
            rfqCreatedBy: 'Created By',
            dealId: 'Deal Id',
            totalPrice: 'Total Price',
            rfqDate: 'RFQ Date',
            submittedBy: 'RFQ Submitted By',
            createdBy: 'Created By',
            vendorName: 'Vendor Name'
        },

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_ORDER_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION_INFORMATION_ICON: 'information tooltip',

        events: {
            'change #select-all-checkbox': 'selectAll',
            'click ul.pagination li a': 'paginate',
            'keypress .tbl-simple-searchInput': 'search',
            'change input#tbl-simple-start-date': 'validateDate',
            'change input#tbl-simple-end-date': 'validateDate',
            'keydown input#tbl-simple-end-date': 'validateDate',
            'keydown input#tbl-simple-start-date': 'validateDate',
            'focusout input#tbl-simple-end-date': 'validateDate',
            'focusout input#tbl-simple-start-date': 'validateDate',

            'change input#tbl-simple-price-lower': 'validatePrice',
            'change input#tbl-simple-price-upper': 'validatePrice',
            'keydown input#tbl-simple-price-lower': 'validatePrice',
            'keydown input#tbl-simple-price-upper': 'validatePrice',

            'change select#tbl-simple-page-size': 'searchFilter',
            'change select#tbl-simple-select': 'searchFilter',
            'change select#tbl-simple-am': 'searchFilter',
            'change select#salesOrg': 'searchFilter',
            'click th': 'columnSort',
            'click td.control': 'styleChildTr',
            'click .tbl-magnifying': 'triggerSearch',
            'mouseenter .order-listing': 'trackingInformationIcon',
            'change .rfQcheckBox': 'selectCheckBoxRfq',
            'change #select-all-checkbox-rfq': 'selectAllRfqCheckboxes',
            'click .closeRfqBtn, .reOpenRfqButton': 'closeRfqFn'
        },

        /**
         * Initialize
         */
        initialize: function () {
            if ($('#tbl-simple-salesorg').length) {
                let url = globals.path.api.quoting.fetchQuotePageItems + `?item=salesOrg`;
                this.getSalesOrg(url, '#tbl-simple-salesorg');
            }

            if (isQuotingSite && $('#salesOrg').length && !$('#salesOrg').is('input')) {
                let url = globals.path.api.quoting.getAllSalesOrgForRfq;
                this.getSalesOrg(url, '#salesOrg', $('#amDefaultSalesOrg').val());
            }

            if ($('#salesOrgDropdown').length) {
                this.getSalesOrgForBulkRenewal();
            }

            this.$tbody = this.$table.children('tbody');
            this.$tableHeaders = this.$('th');
            this.$sortableColumns = this.$table.find('th.sortable');
            this.totalPages = this.$('.tbl-simple-pagination-numbers').data('total');
            this.$currentPage = this.$('.showing-current-page');
            this.$pagination = this.$('.pagination');
            this.$showing = this.$('.tbl-simple-showing');
            this.$selectAll = this.$('.tbl-simple-select-all');
            this.$firstArrow = this.$('.tbl-simple-pagination-numbers ul li.pagination-first-arrow');
            this.$lastArrow = this.$('.tbl-simple-pagination-numbers ul li.pagination-last-arrow');
            this.$tableRow = this.$tbody.children('tr');
            this.$emptyTable = this.$('.tbl-simple-empty');
            this.$emtpyTableCopy = this.$('.tbl-simple-empty-copy');
            this.$manualRMALink = this.$('.manual-RMA-link');
            this.$tableSimpleHeader = this.$('.tbl-simple-header');
            this.$tableSimpleFooter = this.$('.tbl-simple-footer');
            this.$tableSimpleFilters = this.$('.tbl-simple-filters');
            this.$tableSpinner = this.$('.tbl-simple-spinner');
            this.$tableDelaySpinner = this.$('.tbl-delay-table-spinner');
            this.error = false;

            //Filters
            this.$searchInput = this.$('.tbl-simple-searchInput');
            this.$statusInput = this.$('#tbl-simple-select');
            this.$sourceInput = this.$('#tbl-simple-source');
            this.$quoteNumber = this.$('#tbl-quote-number');
            this.$copyQuoteOption = this.$('#tbl-copy-quote-option');
            this.$amInput = this.$('#tbl-simple-am');
            this.$salesOrgValue = this.$('.sales-org');
            this.$salesOrg  = this.$('#salesOrg');
            this.$priceInputLower = this.$('input#tbl-simple-price-lower');
            this.$priceInputUpper = this.$('input#tbl-simple-price-upper');
            this.$pageSizeInput = this.$('select#tbl-simple-page-size');
            this.$allSearchCriteria = this.$('.tbl-criteria');
            this.searchType = this.$('#searchType');
            this.$errorMessage = this.$('.error-message');
            this.$priceerror = this.$('.price-error');
            this.$dateError = this.$('.date-error');
            this.$validDateError = this.$('.valid-date-error');
            this.$searcherrors = this.$('.search-errors');
            this.$apiErrors = this.$('.api-errors');
            this.$perPageFilter = this.$('.tbl-simple-page');
            this.$clearFilterButton = this.$('.tbl-clear-filter');
            this.$applyFilterBtn = $('#applyFilterBtn');
            this.showClearFilterButton = true;
            this.isAllCheckboxdisabled = [];

            //initialize all customized (select2) dropdowns
            var selectMenus = _.filter(this.$allSearchCriteria, function(item) {
                return $(item).is('select');
            });

            if ($('#tbl-simple-am').length) {
                this.getAccManager();
            }

            if ($('#renewalsExecutiveFilter').length) {
                this.fetchRenewalExecutives();
            }

            $(selectMenus).each(function() {
                $(this).select2();
            });

            this.$salesOrg.select2();

            //get default dropdown vals (so clear search/filter can reset them)
            this.filterDefaultVals = this.storeDefaultValues(this.$allSearchCriteria);

            this.pageSizeDefault = this.$pageSizeInput.val();

            this.urlVars = this.getUrlVars();
            this.currentPageParams = this.$('input[name="currentPageParam"]').val();
            this.$error = this.$('.error-message');
            this.$apiError = this.$('.api-error-message');

            //sort vars
            this.sortCode = null;
            this.sortColumn = null;

            //calendar fields
            this.$startDateImg = this.$('.tbl-simple-start-date');
            this.$endDateImg = this.$('.tbl-simple-end-date');
            this.$startDateInput = this.$('#tbl-simple-start-date');
            this.$endDateInput = this.$('#tbl-simple-end-date');
            this.$clearSelectElement = this.$('.non-sticky');

            // Due date range
            this.$startDueDateImg = this.$('.tbl-simple-due-start-date');
            this.$endDueDateImg = this.$('.tbl-simple-due-end-date');
            this.$startDueDateInput = this.$('#tbl-simple-start-due-date');
            this.$endDueDateInput = this.$('#tbl-simple-end-due-date');
            this.$dateDueError =  this.$('.date-error-due');
            this.$validDueDateError = this.$('.valid-date-due-error');

            //create Date

            this.$startCreateDateImg = this.$('.tbl-simple-create-start-date');
            this.$endCreateDateImg = this.$('.tbl-simple-create-end-date');
            this.$startCreateDateInput = this.$('#tbl-simple-create-start-date');
            this.$endCreateDateInput = this.$('#tbl-simple-create-end-date');

            // Contract Due date Range
            this.$startContractDueDateImg = this.$('.tbl-simple-contract-due-start-date');
            this.$endContractDueDateImg = this.$('.tbl-simple-contract-due-end-date');
            this.$startContractDueDateInput = this.$('#tbl-simple-start-contract-due-date');
            this.$endContractDueDateInput = this.$('#tbl-simple-end-contract-due-date');
            this.$dateContractDueError =  this.$('.date-contract-error-due');
            this.$validContractDueDateError = this.$('.valid-contract-date-due-error');

            //AM reseller table needs to override default model to parse response, so model initialized before initialize method called
            if (!this.model) {
                this.model = new ws.models.quoteTableData();
            }

            // Model Events
            this.model.on('change:historyUrl', this.setHistory, this);

            // Setting initial page number into history
            this.model.set({historyUrl: this.currentPageParams}, {silent: true});

            //ClearFilter
            this.eventAgg.on(this.$clearFilterButton.attr('id') + 'clearSearch', this.clearSearch, this);

            this.eventAgg.on('accountSearch', this.search, this);
            this.eventAgg.on('resetSortColumns', this.resetSortColumns, this);
            this.eventAgg.on('searchFilterForApplyQuote', this.searchFilter, this);

            $('#applyFilterBtn').on('click', this.triggerApplyFilter.bind(this));
            $('.viewPackingSlipButton').on('click', this.handlePackingSlipButtonEvent.bind(this));
            $('.viewCarrierTrackingButtonPdf').on('click', this.handlePackingSlipButtonPdfEvent.bind(this));

            this.$datepicker = this.$('.datepicker');
            this.startDate = new Date();
            this.endDate = new Date();
            this.eventAgg.on(this.$table.attr('id') + 'resetPikaday', this.resetPikaday, this);
            if (this.renderOnPageLoad !== false) {
                this.render();
            }

            this.sortClick = '';

            if (window.location.href.indexOf('quotes') > 0 || window.location.href.indexOf('orders') > 0) {
                $('.message-link').empty();
            }

            setTimeout(() => {
                $(document).on('focusout', '.qut-req-input', (e) => {
                    this.quoteLinkRemove(e);
                });
            }, 1000);

            $(document).on('click', '#tbl-simple-venders', (e) => {
                if ($('#tbl-simple-venders option').length === 0) {
                    this.getVendors();
                }
            });

            $(document).on('click', '#tbl-simple-createdBy', (e) => {
                if ($('#tbl-simple-createdBy option').length === 0) {
                    this.getCreatedBy();
                }
            });
        },

        getAccManager: function () {
            $.ajax({
                url: globals.path.api.quoting.getAccountManager,
                type: 'GET',
                success: (response) => {
                    if (response) {
                        $('#tbl-simple-am').empty();
                        let options = `<option value=''></option>`;
                        _.each(response, (accmanagers) => {
                            options += `<option value="${accmanagers.code}" ${accmanagers.defaultSelect ? 'selected="selected"' : ''}>${accmanagers.name}</option>`;
                        });

                        $('#tbl-simple-am').append(options);
                        $('#tbl-simple-am').select2();
                    }
                },

                fail: function(response) {
                    console.error(response);
                }
            });
        },

        getCreatedBy: function () {
            $.ajax({
                url: globals.path.api.quoting.fetchQuotePageItems + `?item=createdBy`,
                type: 'GET',
                success: (response) => {
                    if (response) {
                        $('#tbl-simple-createdBy').empty();
                        let options = `<option value=''></option>`;
                        _.each(response, (accmanagers) => {
                            options += `<option value="${accmanagers.code}" ${accmanagers.defaultSelect ? 'selected="selected"' : ''}>${accmanagers.name}</option>`;
                        });

                        $('#tbl-simple-createdBy').append(options);
                        $('#tbl-simple-createdBy').select2();
                        $('#tbl-simple-createdBy').select2('open');
                    }
                },

                fail: function(response) {
                    console.error(response);
                }
            });
        },

        getSalesOrg: function (url, id, defaultSalesOrgFromModel) {
            $.ajax({
                url: url,
                type: 'GET',
                async: false,
                success: (response) => {
                    if (response && response.length) {
                        $(id).empty();
                        const useSavedFilters = $('#useSavedFilters').val() === 'true';
                        const salesOrgFilter = $('#salesOrgFilter').val();
                        let amDefaultSalesOrg = '';
                        if (response && response.length > 0) {
                            if (defaultSalesOrgFromModel) {
                                amDefaultSalesOrg = defaultSalesOrgFromModel;
                            } else {
                                const defaultSalesOrg = response.find(salesOrg => salesOrg.defaultSelect);
                                if (defaultSalesOrg) {
                                    amDefaultSalesOrg = defaultSalesOrg.code;
                                }
                            }
                        }

                        if (useSavedFilters && !salesOrgFilter) {
                            const isDefaultEmpty = !response.some(salesOrg => salesOrg.code === amDefaultSalesOrg);
                            const emptyOption = `<option value='' data-is-default="${isDefaultEmpty ? 'true' : 'false'}" selected='selected'></option>`;
                            $(id).append(emptyOption);
                        }
            
                        let options = '';
                        _.each(response, (salesOrg) => {
                            let isSelected = false;
                            if (useSavedFilters) {
                                if (!salesOrgFilter) {
                                    isSelected = (salesOrg.code === '');
                                } else {
                                    isSelected = (salesOrg.code === salesOrgFilter);
                                }
                            } else {
                                isSelected = (salesOrg.code === amDefaultSalesOrg);
                            }
            
                            options += `<option value="${salesOrg.code}" data-is-default="${salesOrg.code === amDefaultSalesOrg ? 'true' : 'false'}" ${isSelected ? 'selected="selected"' : ''}>${salesOrg.name}</option>`;
                        });
            
                        $(id).append(options);
                        $(id).select2();
                    } else {
                        $('.tbl-simple-salesorg').addClass('hide');
                    }
                },
            
                fail: function(response) {
                    console.error(response);
                }
            });            
        },

        getSalesOrgForBulkRenewal: function () {
            $.ajax({
                url: globals.path.api.quoting.getAllSalesOrgForRenewals,
                type: 'GET',
                success: (response) => {
                    if (response) {
                        $('#salesOrgDropdown').empty();
                        let options = `<option value=''>Select</option>`;
                        _.each(response, (salesOrgs) => {
                            let isSelected = salesOrgs.code === $('#amDefaultSalesOrg').val() ? 'selected="selected"' : '';
                            let isDefault = salesOrgs.code === $('#amDefaultSalesOrg').val() ? 'true' : 'false';
                            let projectNoSearchEnabled = salesOrgs.projectNoSearchEnabled ? salesOrgs.projectNoSearchEnabled : '';
        
                            options += `
                                <option value="${salesOrgs.code}" 
                                        data-is-default="${isDefault}" 
                                        data-projectnosearch="${projectNoSearchEnabled}" 
                                        ${isSelected}>
                                    ${salesOrgs.name}
                                </option>`;
                        });
        
                        $('#salesOrgDropdown').append(options);
                        $('#salesOrgDropdown').select2();
                    }
                },
                fail: function(response) {
                    console.error(response);
                }
            });
        },

        getVendors: function () {
            $.ajax({
                url: globals.path.api.quoting.fetchQuotePageItems + `?item=vendor`,
                type: 'GET',
                success: (response) => {
                    if (response) {
                        $('#tbl-simple-venders').empty();
                        let options = `<option value=''></option>`;
                        _.each(response, (vendors) => {
                            options += `<option value="${vendors.code}" ${vendors.defaultSelect ? 'selected="selected"' : ''}>${vendors.name}</option>`;
                        });

                        $('#tbl-simple-venders').append(options);
                        $('#tbl-simple-venders').select2();
                        $('#tbl-simple-venders').select2('open');
                    }
                },

                fail: function(response) {
                    console.error(response);
                }
            });
        },

        fetchRenewalExecutives: function() {
            $.ajax({
                url: globals.path.api.quoting.fetchRenewalExecutivesQuotingQuotes,
                type: 'GET',
                success: (response) => {
                    if (response) {
                        $('#renewalsExecutiveFilter').empty();
                        let options = `<option value=''></option>`;
                        _.each(response, (executive) => {
                            options += `<option value="${executive.uid}" ${executive.uid == $('#renewalsExecutiveFilterInput').val() ? 'selected="selected"' : ''}>${executive.name}</option>`;
                        });

                        $('#renewalsExecutiveFilter').append(options);
                        $('#renewalsExecutiveFilter').select2();
                    }
                },

                fail: function(response) {
                    console.error(response);
                }
            });
        },

        quoteLinkRemove: function (e) {
            let data = {
                rfqId: $(e.currentTarget).data('rfqid'),
                quoteId: $(e.currentTarget).data('value'),
                action: 'remove'
            };

            $.ajax({
                url: globals.path.api.quoting.linkQuoteToRfq + '?' + CSRF,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: (response) => {
                    if (response) {
                        this.eventAgg.trigger('searchFilterForApplyQuote');
                        this.closeModal();
                    }
                },

                fail: function(response) {
                    globals.enableApp();
                    console.error(response);
                }
            });
        },

        /**
         * Reset sort columns
         */
        resetSortColumns () {
            this.sortCode = null;
            this.sortColumn = null;
            this.$sortableColumns.removeClass('asc').removeClass('desc');
        },

        /**
         * Render
         */
        render: function () {
            this.initializePikaday();

            if (this.renderWithApi === true) {
                this.model.url = this.renderWithApiUrl;
                this.$tableSpinner.show();
                this.$emtpyTableCopy.hide();
                this.$manualRMALink.hide();
                this.$table.dataTable().fnClearTable();
                this.$table.DataTable().destroy();
                this.model.fetch().done(function (data) {
                    this.$tableSpinner.hide();
                    this.calculateShowing(data.paginationData);
                    this.calculatePagination(data.paginationData);
                    this.renderRows(data.data);
                }.bind(this)).fail(function () {
                    this.tableGenericError();
                }.bind(this));
            } else {
                this.$clearFilterButton.toggle(_.keys(this.urlVars).length >= 2);
                if (_.keys(this.urlVars).length >= 2) {
                    this.$('.message-link').hide();
                }

                this.fadeInRows();
                this.initializeDataTable();
            }
        },

        /**
         * Grab all of the filters' default values.
         *
         * @param {jQuery[]} collection
         * @returns {Array.<{id: string, value: string}>}
         */
        storeDefaultValues: function(collection) {
            const obj = [];

            $(collection).each(function() {
                const item = {};
                const $this = $(this);

                item.id = $(this).attr('id');
                if ($this.is('select') && typeof $this.data('use-default-values') === 'undefined') {
                    // Selects can have a default option identified by a data-default
                    // attribute being set to true; if it exists, use that option's value
                    item.value = $this.find('option[data-is-default="true"]').val();
                    if (_.isUndefined(item.value)) {
                        item.value = $this[0].value;
                    }
                }
                else {
                    // All other defaults are blank
                    item.value = '';
                }

                obj.push(item);
            });

            return obj;
        },

        /**
         * Handle generic table error
         */
        tableGenericError: function () {
            this.$tableSpinner.hide();
            this.$emptyTable.show();
            this.$emtpyTableCopy.show();
            this.$emtpyTableCopy.removeClass('hide');
            this.$manualRMALink.show();
            this.$apiError.show();
        },

        /**
         * Hide generic table error
         */
        hideGenericErrors: function () {
            this.$tableSpinner.hide();
            this.$emptyTable.hide();
            this.$emtpyTableCopy.hide();
            this.$emtpyTableCopy.addClass('hide');
            this.$manualRMALink.hide();
            this.$apiError.hide();
        },

        /**
         * checkOrderInHybris
         */
        checkOrderInHybris: function(e) {
            $('.invalid-order').hide();
            globals.disableApp();

            this.model.url = this.checkOrder + '/' + $(e.currentTarget).data('ordernum');

            this.model.fetch().done(function (data) {
                globals.enableApp();

                dataLayerAA.event = {};
                dataLayerAA.event.category = 'license_activity';
                dataLayerAA.event.action = 'clicks order';
                dataLayerAA.event.label = $(e.currentTarget).data('ordernum');

                dataLayerAA.order = {};
                dataLayerAA.order.sapNo = $(e.currentTarget).data('ordernum');

                dataLayerAA.search = {};

                _satellite.track('event:licenses');
                dataLayer.push({event: 'new_gtm_event'});

                if (data.errorMsg != null) {
                    $('.invalid-order').show();
                    $('.salesOrderNumber').text($(e.currentTarget).data('ordernum'));
                    $('html, body').animate({scrollTop: $('.invalid-order').offset().top - 200}, 2000, 'swing');
                } else if (data.orderDetailURL != null) {
                    location.href = sitePath + data.orderDetailURL;
                }

            }.bind(this)).fail(function () {
                globals.enableApp();
            }.bind(this));
        },

        /**
         *  Unsetting the unneccessary parameters from the request
         */
        unsetParams: function () {
            this.model.unset('order');
            this.model.unset('highPrice');
            this.model.unset('lowPrice');
            this.model.unset('source');
            this.model.unset('paginationData');
            this.model.unset('data');
            this.model.unset('type');
        },

        /**
         * Load Data Tables
         */
        initializeDataTable: function (sorting, quantity) {
            var _this = this;
            var targetControlColumn = 1;
            var targetControlType = 'column';

            var columnDefs = [
                {
                    targets: '_all',
                    width: 'auto'
                },
                {
                    targets: targetControlColumn,
                    className: 'control',
                    orderable: false,
                    width: '10%'
                },
                {
                    targets: 'checkbox',
                    width: '0%',
                    orderable: false
                }
            ];

            //if control column is the first one (instead of the second one, like for tables that have checkboxes), then override some dataTables defaults
            if (this.controlColumn !== 'undefined' && this.controlColumn === 0) {
                targetControlColumn = 0;
                targetControlType = 'inline';
                columnDefs = [
                    {
                        targets: '_all',
                        width: 'auto'
                    },
                    {
                        targets: targetControlColumn,
                        className: 'control',
                        orderable: false,
                        width: '10%'
                    }
                ];
            }

            if (quantity) {
                columnDefs = [{
                    targets: 5,
                    orderable: false
                }];
            }

            var options = {
                bFilter: false,
                bInfo: false,
                bLengthChange: false,
                bPaginate: false,
                bSort: sorting ? true : false,
                bSortable: false,
                bRetrieve: true,
                aSorting: [[]],
                responsive: {
                    details: {
                        type: targetControlType,
                        target: targetControlColumn
                    }
                },

                /**
                 * Show empty component if no data to render
                 */
                fnDrawCallback: function () {
                    var rows = this.fnGetData();
                    if (rows.length === 0) {
                        $('td.dataTables_empty').hide();
                        _this.$emptyTable.show();
                        _this.$emtpyTableCopy.show();
                        _this.$emtpyTableCopy.removeClass('hide');
                        _this.$manualRMALink.show();
                        _this.$tableSimpleHeader.css('visbility', 'hidden');
                        _this.$tableSimpleFooter.hide();
                    } else {
                        _this.$emptyTable.hide();
                        _this.$emtpyTableCopy.hide();
                        _this.$emtpyTableCopy.addClass('hide');
                        _this.$manualRMALink.hide();
                        _this.$tableSimpleHeader.css('visibility', 'visible');
                        _this.$tableSimpleFooter.show();
                    }
                },

                bAutoWidth: false,
                columnDefs: columnDefs
            };

            if (this.rowCallback && typeof this.rowCallback === 'function') {
                options.rowCallback = this.rowCallback.bind(this);
            }

            //define column stacking priority
            if (this.responsivePriority && typeof this.responsivePriority !== 'undefined') {
                options.columns = this.responsivePriority;
            }

            //control which column is responsive control
            if (this.responsiveOptions && typeof this.responsiveOptions !== 'undefined') {
                options.responsive = this.responsiveOptions;
            }

            if (this.columnDefsOptions && typeof this.columnDefsOptions !== 'undefined') {
                options.columnDefs = this.columnDefsOptions;
            }

            this.$table.DataTable(options);
        },

        /**
         * Fade in rows
         */
        fadeInRows: function () {
            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loading');
            });

            this.$tbody.find('tr > td').each(function (i, row) {
                $(row).animate({
                    opacity: 1
                });
            });
        },

        /**
         * Render page data
         * @param {string} url
         */
        renderTable: function (url) {
            //animation to be improved later
            this.model.url = url;
        },

        /**
         * Render a table row (what kind of data?)
         * @param {Object} result
         */
        renderRows: function (result) {
            var options;
            var _this = this;
            _.each(result, function (row) {
                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         * Render a table Collection
         * @param {Object} result
         */
        renderTableData: function (result) {
            var options = {
                collection: result,
                rowTemplate: this.rowTemplate
            };
            var quickTable = new ws.views.simpleTableQuickView(options);
            this.$table.find('tbody').remove();
            this.$table.append(quickTable.render().el);

            // To make table responsive
            var targetControlColumn = 1;
            var targetControlType = 'column';

            var columnDefs = [
                {
                    targets: '_all',
                    width: 'auto'
                },
                {
                    targets: targetControlColumn,
                    className: 'control',
                    orderable: false,
                    width: '10%'
                },
                {
                    targets: 'checkbox',
                    width: '0%',
                    orderable: false
                }
            ];

            //if control column is the first one (instead of the second one, like for tables that have checkboxes), then override some dataTables defaults
            if (this.controlColumn !== 'undefined' && this.controlColumn === 0) {
                targetControlColumn = 0;
                targetControlType = 'inline';
                columnDefs = [
                    {
                        targets: '_all',
                        width: 'auto'
                    },
                    {
                        targets: targetControlColumn,
                        className: 'control',
                        orderable: false,
                        width: '10%'
                    }
                ];
            }

            var optionsTable = {
                responsive: {
                    details: {
                        type: targetControlType,
                        target: targetControlColumn
                    }
                },

                columnDefs: columnDefs
            };

            if (this.rowCallback && typeof this.rowCallback === 'function') {
                optionsTable.rowCallback = this.rowCallback.bind(this);
            }

            //define column stacking priority
            if (this.responsivePriority && typeof this.responsivePriority !== 'undefined') {
                optionsTable.columns = this.responsivePriority;
            }

            //control which column is responsive control
            if (this.responsiveOptions && typeof this.responsiveOptions !== 'undefined') {
                optionsTable.responsive = this.responsiveOptions;
            }

            if (this.columnDefsOptions && typeof this.columnDefsOptions !== 'undefined') {
                optionsTable.columnDefs = this.columnDefsOptions;
            }

            this.$table.DataTable(optionsTable);
        },

        /**
         * Style child tr when it gets created
         */
        styleChildTr: function (e) {
            var tr = $(e.currentTarget).closest('tr');
            var rowClass = $(tr).attr('class');
            var childTr = $(tr).next();

            if ($(childTr).hasClass('child')) {
                $(childTr).addClass(rowClass);
                $(childTr).removeClass('parent');
            }

            if (isEcomSite) {
                const quoteId = tr.find('a').text();
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'expand_quote', quoteId);
            }
        },

        /**
         * Pushed the correct state to the browser history
         */
        setHistory: function () {
            // TODO: fix history for ie9
            if (win.history.pushState) {
                win.history.pushState({page: this.model.get('historyUrl')}, 'Page', this.model.get('historyUrl'));
            }
        },

        /**
         * Trigger Search
         */
        triggerSearch: function () {
            const e = $.Event('keypress', {which: 13});
            this.$searchInput.trigger(e);
        },

        /**
         * Trigger Apply Filter
         * @param {Object} e
         */
        triggerApplyFilter: function (e) {
            e.preventDefault();
            if (this.error === false) {
                this.toggleApplySearchBtn(false);
                this.searchFilter(e);
            }
        },

        /**
         * Paginate
         * @param {Object} e
         */
        paginate: function (e) {
            e.preventDefault();
            var urlParams = '';

            //if paginating on search results, use searchFilter API
            if (this.$pagination.hasClass('search')) {
                urlParams = $(e.currentTarget).attr('href');
                var page = urlParams.substring(6);
                this.searchFilter(e, page);
            } else {
                //reset sort col params
                this.sortCode = '';
                this.sortColumn = '';

                //otherwise, just use paging api
                urlParams = $(e.currentTarget).attr('href') || '';

                if (e.state && Object.keys(e.state).length) {
                    urlParams = e.state.page;

                } else {
                    this.model.set({historyUrl: urlParams});
                }

                this.model.url = this.paginateUrl + urlParams;

                //clear table of rows
                this.$table.dataTable().fnClearTable();
                this.$table.DataTable().destroy();

                this.$tableSpinner.show();
                this.$emtpyTableCopy.hide();
                this.$manualRMALink.hide();
                if ($('#qut-openAddProductModal').is(':visible')) {
                    this.model.fetch({
                        type: 'POST',
                        data: JSON.stringify(this.extraParams),
                        contentType: 'application/json',
                        processData: false
                    }).done(function (data) {
                        this.$tableSpinner.hide();
                        this.calculateShowing(data.paginationData);
                        this.calculatePagination(data.paginationData);
                        this.renderRows(data.data);
                    }.bind(this)).fail(function () {
                        this.tableGenericError();
                    }.bind(this));
                } else {
                    this.model.fetch({
                        data: this.extraParams
                    }).done(function (data) {
                        this.$tableSpinner.hide();
                        this.calculateShowing(data.paginationData);
                        this.calculatePagination(data.paginationData);
                        this.renderRows(data.data);
                    }.bind(this)).fail(function () {
                        this.tableGenericError();
                    }.bind(this));
                }
            }
        },

        /**
         * Search
         * @param {Object} e
         */
        search: function (e) {
            if (e.which === 13) {
                e.preventDefault();
                if (e.target.value) {
                    this.searchFilter(e);
                    this.$clearFilterButton.show();
                    this.$('.message-link').hide();
                    this.$searcherrors.hide();
                    this.$apiErrors.hide();
                } else {
                    this.$searcherrors.removeClass('hide');
                    this.$searcherrors.show();
                    this.checkSearchEmpty();
                }
            }
        },

        /**
         * Search
         */
        checkSearchEmpty: function () {
            var searchText = this.$searchInput.val();
            var statusText = this.$statusInput.val();
            var sourceText = this.$sourceInput.val();
            var amText = this.$amInput.val();
            var beginningDate = this.$startDateInput.val();
            var endDate = this.$endDateInput.val();
            var lowerPriceLimit = parseFloat(this.$priceInputLower.val());
            var upperPriceLimit = parseFloat(this.$priceInputUpper.val());

            if (searchText || statusText || beginningDate || endDate || lowerPriceLimit || upperPriceLimit || amText || sourceText) {
                this.$searcherrors.hide();
            }
        },

        /**
         * Sort column
         * @param {Object} e
         */
        columnSort: function (e) {
            var $el = $(e.target);

            //only search on click of columns that we sort by
            if ($el.hasClass('sortable')) {
                this.sortColumn = $el.data('attr');
                this.sortCode = 'asc';

                //if no asc or desc, then begin sort with asc order
                if (!$el.hasClass('asc') && !$el.hasClass('desc')) {
                    this.sortCode = 'asc';
                    this.$sortableColumns.removeClass('asc').removeClass('desc'); //remove sort of other columns
                    $el.addClass('asc');
                } else if ($el.hasClass('asc')) {
                    //if column sorted in asc, resort in desc order
                    this.sortCode = 'desc';
                    this.$sortableColumns.removeClass('asc').removeClass('desc'); //remove sort of other columns
                    $el.addClass('desc');
                    $el.removeClass('asc');

                } else if ($el.hasClass('desc')) {
                    //if column sorted in desc, resort in asc order
                    this.sortCode = 'asc';
                    this.$sortableColumns.removeClass('asc').removeClass('desc'); //remove sort of other columns
                    $el.addClass('asc');
                    $el.removeClass('desc');
                }

                //add search class to pagination, so that upon pagination of search results correct API is called
                this.$pagination.addClass('search');

                //only sort if there is an attribute to sort against
                if (this.sortColumn) {
                    if (isEcomSite) {
                        this.sortClick = (this.sortClick !== '') ? this.sortClick + '-' + this.sortColumn : this.sortColumn;
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'sort_quote', this.sortClick);
                    }

                    this.searchFilter();
                }
            }
        },

        /**
         * is Number function
         * @param {Object} e
         * @returns {boolean}
         */
        isNumber: function (e) {
            e = (e) ? e : window.event;

            var charCode = e.which || e.keyCode;

            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                e.preventDefault();
            }

            return true;
        },

        /**
         * Check date fields
         */
        validateDate: function (e, makeApiCall = true) {
            // if pressing enter key, prevent refresh (since some tables are forms)
            //e may not be defined if date changed happens from pikaday

            if (e && (e.keyCode === 13 || e.which === 13)) {
                e.preventDefault();
            }

            var beginningDate = this.$startDateInput.val();
            var endDate = this.$endDateInput.val();
            var beginDateValid = globals.validateDate(beginningDate);
            var endDateValid = globals.validateDate(endDate);

            //remove error classes
            this.$startDateInput.removeClass('error');
            this.$endDateInput.removeClass('error');
            this.$dateError.hide();
            this.$validDateError.hide();
            this.$searcherrors.hide();

            //show start date error
            if (beginDateValid === false) {
                this.$startDateInput.addClass('error');
                this.$dateError.show();
            }

            //show end date error
            if (endDateValid === false) {
                this.$endDateInput.addClass('error');
                this.$dateError.show();
            }

            //check for start date is less than end date
            var validCheck = '';
            if (endDateValid && beginDateValid) {
                validCheck = globals.compareDates(beginningDate, endDate);
                if (!validCheck) {
                    this.$validDateError.show();
                }
            }

            //if no errors and either enter key pressed, or change made from pikaday, make api call
            if (beginDateValid === true && endDateValid === true && validCheck === true && ((e.keyCode === 13 || e.which === 13) || (e === 'pikaday')) && makeApiCall) {
                var gaEventLabel = beginningDate + ',' + endDate + '_date_range';
                this.searchFilter(e, undefined, gaEventLabel);
            }

        },

        /**
         * Check price fields
         */
        validatePrice: function (e, makeApiCall = true) {
            this.$searcherrors.hide();
            var keyCode = e.keyCode || e.which;

            //if pressing enter key, prevent refresh (since some tables are forms)
            if (keyCode === 13) {
                e.preventDefault();
            }

            var lowerPriceLimit = this.$priceInputLower.val();
            var upperPriceLimit = this.$priceInputUpper.val();
            var error = false;

            //remove error classes from price inputs
            this.$priceerror.hide();
            this.$priceInputLower.removeClass('error');
            this.$priceInputUpper.removeClass('error');

            //make sure inputs are numbers
            if (isNaN(lowerPriceLimit)) {
                this.$priceInputLower.addClass('error');
                error = true;
            }

            if (isNaN(upperPriceLimit)) {
                this.$priceInputUpper.addClass('error');
                error = true;
            }

            //make sure lower price is less than upper price
            if (lowerPriceLimit && upperPriceLimit && (parseFloat(lowerPriceLimit) > parseFloat(upperPriceLimit))) {
                this.$priceInputLower.addClass('error');
                this.$priceInputUpper.addClass('error');
                this.$priceerror.show();
                error = true;
            }

            this.error = error;

            //only search if enter key pressed
            if (error === false && keyCode === 13 && makeApiCall) {
                var gaEventLabel = lowerPriceLimit + ',' + upperPriceLimit + '_price_range';
                this.searchFilter(e, undefined, gaEventLabel);
            }
        },

        toggleMessageOnFilter: function () {
            let notFiltering = true;
            _.each($('.tbl-simple-filter').find('input[type="text"], select, select.tbl-criteria, input:checked'), function ($field) {
                if ($($field).val() !== '' && $($field).val() !== null && $($field).val() !== 'Select') {
                    notFiltering = false;
                }
            });

            $('.headerlineLevelOptions input:checkbox:checked').each(function () {
                if ($(this).attr('data-value')) {
                    notFiltering = false;
                }
            });

            if (window.location.href.indexOf('quotes') > 0 && $('.tbl-simple-filters .tbl-simple-searchInput').val()) {
                notFiltering = false;
            }

            if (!notFiltering) {
                this.$('.message-link').hide();
                this.$('.tbl-clear-filter').show();
            } else {
                this.$('.message-link').show();
                this.$('.tbl-clear-filter').hide();
            }
        },

        /**
         * Call search/filter api and pushing the data to Google Analytics
         * @param {Event} [e]
         * @param {string} [page]
         * @param {string} [gaEventLabel]
         *
         */
        searchFilter: function (e = undefined, page = undefined, gaEventLabel = undefined) {
            this.$searcherrors.hide();
            this.$apiErrors.hide();
            var searchProperty = this.searchType.val();
            var searchText = this.$searchInput.val();
            var statusText = this.$statusInput.val() === this.$statusInput.data('placeholder') ? '' : this.$statusInput.val();
            var statusList = [];
            $('.headerlineLevelOptions input:checkbox:checked').each(function () {
                statusList.push($(this).attr('data-value'));
            });
            var sourceText = this.$sourceInput.val() === this.$sourceInput.data('placeholder') ? '' : this.$sourceInput.val();
            var amText = this.$amInput.val();
            var quoteNumber = !_.isUndefined(this.$quoteNumber) ? this.$quoteNumber.val() : '';
            var copyQuoteOption = !_.isUndefined(this.$copyQuoteOption) ? this.$copyQuoteOption.val() : '';
            var beginningDate = this.$startDateInput.val();
            var endDate = this.$endDateInput.val();
            var startDueDate = this.$startDueDateInput.val();
            var endDueDate = this.$endDueDateInput.val();
            var startContractDueDate = this.$startContractDueDateInput.val();
            var endContractDueDate = this.$endContractDueDateInput.val();
            var lowerPriceLimit = parseFloat(this.$priceInputLower.val());
            var upperPriceLimit = parseFloat(this.$priceInputUpper.val());
            var createStartDate = this.$startCreateDateInput.val();
            var createEndDate = this.$endCreateDateInput.val();
            var pageSize = this.$pageSizeInput.val();
            var selectedSalesOrg = !_.isUndefined(this.$salesOrgValue.val()) ? this.$salesOrgValue.val() : this.$salesOrg.val();
            this.error = false;

            //don't show clear filter button if changing page size
            this.showClearFilterButton = e && $(e.currentTarget).attr('id') !== 'tbl-simple-page-size' && !page || this.$clearFilterButton.is(':visible');

            var request = {
                amFilter: amText,
                searchText: searchText,
                searchProperty: searchProperty,
                quoteCloseFromDate: startDueDate,
                quoteCloseToDate: endDueDate,
                contractDueFromDate: startContractDueDate,
                contractDueToDate: endContractDueDate,
                fromDate: beginningDate,
                toDate: endDate,
                lowPrice: lowerPriceLimit,
                highPrice: upperPriceLimit,
                sortCode: this.sortColumn,
                order: this.sortCode,
                sortType: this.sortCode,
                salesOrg: selectedSalesOrg,
                page: page, //failing on search rfq by price
                pageSize: pageSize,
                status: statusText,
                statusList: statusList,
                source: sourceText,
                type: sourceText,
                quoteNum: quoteNumber,
                copyQuoteOption: copyQuoteOption,
                creationFromDate: createStartDate,
                creationToDate: createEndDate,
                paginationData: '', //makes sure this is not an object, otherwise BE error
                data: ''
            };

            // update request object if filters for table are not the usual search criteria, input field, date, price range ones
            if (this.overrideFilterRequest === true) {
                request = this.customFilterRequest(request);
            }

            /**
             * Checking the store site and handling event tracking for Google Analytics
             * GTM_EVENT_CATEGORY and GTM_EVENT_ACTION inherited from accountquotetable view
             *
             */
            if (isEcomSite) {
                if (e && $(e.currentTarget).attr('id') === 'tbl-simple-select') {
                    this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'filter_quote', 'status_' + $(e.currentTarget).val());
                } else if (e && $(e.currentTarget).attr('class') === 'tbl-simple-searchInput') {
                    this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, this.gtmFilterOptions[searchProperty]);
                } else if (gaEventLabel) {
                    this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'filter_quote', gaEventLabel);
                }
            }

            this.searchFilterCall(request, e);
            this.handleClearSearch(request);
            this.toggleMessageOnFilter();

            //Letting it exefcute after all functions are done executing because
            //satellite library is throwing error sometimes
            $(document).ready(() => {
                try {
                    if (location.href.indexOf('store') > -1) {
                        dataLayerAA.search = {};
                        dataLayerAA.search.type = this.searchCategory;
                        dataLayerAA.search.field = searchProperty;
                        dataLayerAA.search.query = searchText;

                        if ($('#pageName').val() == 'orderlistingpage')
                            dataLayerAA.search.status = statusText;

                        _satellite.track('event:search');
                    }
                } catch (error) {
                    console.log('An error occurred:', error.message);
                }
            });
        },

        /**
         * Call Search Filter API
         * @param {Object} request
         */
        searchFilterCall: function (request, e) {
            this.model.set(request);
            this.model.url = this.searchUrl;
            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            // calling without arguments to hide pagination
            this.calculateShowing();
            this.calculatePagination();

            var selectedSalesOrg = !_.isUndefined(this.$salesOrgValue.val()) ? this.$salesOrgValue.val() : this.$salesOrg.val();
            this.model.save().done(function (data) {
                if (['customerHierarchyError', 'optionalQuoteError'].includes(data.error)) {
                    this.$apiErrors.removeClass('hide');
                    this.$apiErrors.show();
                }

                this.$tableSpinner.hide();
                this.renderRows(data.data);
                this.calculateShowing(data.paginationData);
                this.calculatePagination(data.paginationData);
                $('.totalNumberofResults').html(data.paginationData.totalNumberOfResults);
                this.$pagination.addClass('search');
                this.$clearFilterButton.toggle(this.showClearFilterButton);
                if (this.showClearFilterButton) {
                    this.$('.message-link').hide();
                }

                $('.reseller-search-result-error').addClass('hide');
                if (isQuotingSite) { 
                    if (this.model.url.includes('searchunits') && data.error) {
                        $('.reseller-search-result-error').text(data.error).removeClass('hide');
                    }

                    let showEmailifLinkQuoteNoEnabledSubmitted = $('#enableNewRFQConfiguration').val() === 'true' ? [1, 2, 3, 6, 21] : [1, 2, 3, 6, 20];
                    let hideEmailifLinkQuoteNoEnabledSubmitted = $('#enableNewRFQConfiguration').val() === 'true' ? [5, 7, 8, 18, 19, 20, 22, 23, 24] : [5, 7, 8, 17, 18, 19, 21, 22, 23];
                    let showEmailifLinkQuoteNoEnabledQuoted = $('#enableNewRFQConfiguration').val() === 'true' ? [3, 5, 6, 7, 8, 18, 22, 23, 24] : [3, 5, 6, 7, 8, 21, 22, 23];
                    let hideEmailifLinkQuoteNoEnabledQuoted = $('#enableNewRFQConfiguration').val() === 'true' ? [1, 2, 18, 19, 20, 21] : [1, 2, 17, 18, 19, 20];
                    let showEmailifLinkQuoteNoEnabledClosed = $('#enableNewRFQConfiguration').val() === 'true' ? [1, 18, 19, 20] : [1, 17, 18, 19];
                    let hideEmailifLinkQuoteNoEnabledClosed = $('#enableNewRFQConfiguration').val() === 'true' ? [2, 3, 5, 6, 8, 21, 22, 23, 24] : [2, 3, 5, 6, 7, 9, 10, 20, 21, 22, 23];
                    $('#select-all-checkbox-rfq').prop('checked', false);
                    $('.closeRfqBtn').prop('disabled', true);
                    $('.reOpenRfqButton').prop('disabled', true);
                    if (e && $(e.target).val() === 'RFQ_SUBMITTED' || $('#tbl-simple-select').val() === 'RFQ_SUBMITTED') {
                        $('#rfq-table').DataTable().columns(showEmailifLinkQuoteNoEnabledSubmitted).visible(true);
                        $('#rfq-table').DataTable().columns(hideEmailifLinkQuoteNoEnabledSubmitted).visible(false);
                        $('.closeRfqBtn').removeClass('hidden');
                        $('.reOpenRfqButton').addClass('hidden');
                    } else if (e && $(e.target).val() === 'RFQ_QUOTED' || $('#tbl-simple-select').val() === 'RFQ_QUOTED') {
                        $('#rfq-table').DataTable().columns(showEmailifLinkQuoteNoEnabledQuoted).visible(true);
                        $('#rfq-table').DataTable().columns(hideEmailifLinkQuoteNoEnabledQuoted).visible(false);
                        $('.closeRfqBtn').addClass('hidden');
                        $('.reOpenRfqButton').addClass('hidden');
                    } else if (e && $(e.target).val() === 'RFQ_CLOSED' || $('#tbl-simple-select').val() === 'RFQ_CLOSED') {
                        $('#rfq-table').DataTable().columns(showEmailifLinkQuoteNoEnabledClosed).visible(true);
                        $('#rfq-table').DataTable().columns(hideEmailifLinkQuoteNoEnabledClosed).visible(false);
                        $('.closeRfqBtn').addClass('hidden');
                        $('.reOpenRfqButton').removeClass('hidden');
                    } else {
                        $('#rfq-table').DataTable().columns([2, 3, 5, 6, 7, 8, 17, 18, 19, 20, 21, 22, 23]).visible(true);
                        $('#rfq-table').DataTable().columns([1]).visible(false);
                        $('.closeRfqBtn').addClass('hidden');
                        $('.reOpenRfqButton').addClass('hidden');
                    }

                    let cls = $('.rfQcheckBox');
                    let clsAllCheckbox = $('#select-all-checkbox-rfq');
                    this.enableDisableSelectAllCheckbox(cls, clsAllCheckbox);
                }

                this.toggleApplySearchBtn(true);
            }.bind(this)).fail(function () {
                this.tableGenericError();
            }.bind(this));
        },

        enableDisableSelectAllCheckbox (cls, clsAllCheckbox) {
            _.each(cls,  (checkbox) => {
                if ($(checkbox).prop('disabled')) {
                    this.isAllCheckboxdisabled.push(true);
                } else {
                    this.isAllCheckboxdisabled.push(false);
                }
            });

            if (!this.isAllCheckboxdisabled.includes(false)) {
                $(clsAllCheckbox).prop('disabled', true).next('label').addClass('disableCheckbox');
            } else {
                $(clsAllCheckbox).prop('disabled', false).next('label').removeClass('disableCheckbox');
            }

            this.isAllCheckboxdisabled = [];
        },

        /**
         * Toggle Apply search btn
         * @param {boolean} enable
         */
        toggleApplySearchBtn (enable) {
            if (enable) {
                this.$applyFilterBtn.removeClass('disabled');
                this.$applyFilterBtn.prop('disabled', '');
            } else {
                this.$applyFilterBtn.addClass('disabled');
                this.$applyFilterBtn.prop('disabled', 'disabled');
            }
        },

        /**
         * Track information icon event
         */
        trackingInformationIcon () {
            this.gtmEventTracking(this.GTM_EVENT_ORDER_CATEGORY, this.GTM_EVENT_ACTION_INFORMATION_ICON);
        },

        /**
         * Calculate showing x to y of z values
         * @param {Object} pagination
         */
        calculateShowing: function (pagination) {
            // only show UI elements if there are results
            if (!pagination || pagination.totalNumberOfResults === 0) {
                this.$showing.hide();
                this.$selectAll.hide();
                this.$perPageFilter.hide();
            } else {
                this.$showing.show();
                this.$selectAll.show();
                var showingStart;
                var showingEnd;
                var total = pagination.totalNumberOfResults;
                var numberOfResults = this.$pageSizeInput.find('option').eq(0).val();

                if (total < numberOfResults) {
                    this.$perPageFilter.hide();
                } else {
                    this.$perPageFilter.show();
                }

                if (pagination.currentPage === 0) {
                    //if on the first page
                    showingStart = 1;
                    showingEnd = pagination.pageSize;
                } else if (pagination.currentPage + 1 === pagination.numberOfPages) {
                    //if on the last page
                    showingStart = pagination.pageSize * pagination.currentPage + 1;
                    showingEnd = total;
                } else {
                    //if on any page in between
                    showingStart = pagination.pageSize * pagination.currentPage + 1;
                    showingEnd = pagination.pageSize * (pagination.currentPage + 1);
                }

                // adjust layout if there's only 1 page of results
                if (pagination.totalNumberOfResults < pagination.pageSize) {
                    showingEnd = pagination.totalNumberOfResults;
                }

                this.$('.showing-start').html(showingStart);
                this.$('.showing-end').html(showingEnd);
                this.$('.showing-total-results').html(total);
            }
        },

        enableDelaySpinner: function () {
            let delayTime = $('#searchTimeout').val() ? $('#searchTimeout').val() * 1000 : 10000;
            this.spinnerEnabled = setTimeout(() => {
                globals.enableApp();
                this.$tableSpinner.hide();
                this.$tableDelaySpinner.show();
            }, delayTime);
        },

        disabledDelaySpinner: function () {
            clearTimeout(this.spinnerEnabled);
            this.$tableDelaySpinner.hide();
        },

        /**
         * Calculate pagination based on new results
         * @param {Object} pagination
         */
        calculatePagination: function (pagination) {
            //only show pagination if multiple pages of results
            if (!pagination || pagination.numberOfPages === 1 || pagination.totalNumberOfResults === 0) {
                this.$pagination.hide();
            } else {
                //generate in between <li>
                this.$pagination.show();

                var currentPageNumber = pagination.currentPage;
                var totalNumberPages = pagination.numberOfPages;

                var prevPage = currentPageNumber === 0 ? currentPageNumber : currentPageNumber - 1;
                var nextPage = currentPageNumber + 1;
                var firstArrow = '<li class="pagination-first-arrow" > <a href="?page=' + prevPage + '" class="arrow">&lt;</a> </li>';
                var lastArrow = '<li class="pagination-last-arrow"> <a href="?page=' + nextPage + '" class="arrow">&gt;</a> </li>';
                var numberClass;

                var totalNavShow = 5;
                var miniNavShow = totalNavShow / 2;

                //calculating the start/end of pagination when more than 5 results
                var begin = ((currentPageNumber - miniNavShow) > 0 ? ((currentPageNumber - miniNavShow) < (totalNumberPages - totalNavShow + 1) ? (currentPageNumber - miniNavShow) : (totalNumberPages - totalNavShow)) : 0) + 1;
                var end = (currentPageNumber + miniNavShow) < totalNumberPages ? ((currentPageNumber + miniNavShow) > totalNavShow ? (currentPageNumber + miniNavShow) : totalNavShow) : totalNumberPages;

                this.$pagination.html('');
                if (totalNumberPages < 6) {
                    for (var i = 1; i <= pagination.numberOfPages; i++) {
                        numberClass = currentPageNumber === (i - 1) ? 'current' : '';
                        this.$pagination.append('<li><a href="?page=' + (i - 1) + '" data-page=" ' + i + ' " class="' + numberClass + '">' + i + '</a></li>');
                    }
                } else if (totalNumberPages > 5) {
                    for (var j = begin; j <= end; j++) {
                        numberClass = currentPageNumber === (Math.round(j) - 1) ? 'current' : '';
                        this.$pagination.append('<li><a href="?page=' + (Math.round(j) - 1) + '" data-page=" ' + Math.round(j) + ' " class="' + numberClass + '">' + Math.round(j) + '</a></li>');
                    }
                }

                if (currentPageNumber === 0 && totalNumberPages > 5) {

                    //if on the first page
                    this.$pagination.append(lastArrow);
                } else if ((currentPageNumber + 1 === totalNumberPages) && totalNumberPages > 5) {

                    //if on the last page
                    this.$pagination.prepend(firstArrow);
                } else if (totalNumberPages > 5) {

                    //if on any page in between
                    this.$pagination.prepend(firstArrow);
                    this.$pagination.append(lastArrow);
                }
            }
        },

        /**
         * Hide pagination element
         */
        hidePagination: function () {
            this.$pagination.hide();
        },

        /**
         * Clear Search Results (currently calling first page results)
         * @param {Object} e
         * @param {string} [clearFilterUrl]
         */
        clearSearch: function (e, clearFilterUrl, favorite) {
            e.preventDefault();
            this.$clearFilterButton.hide();
            this.$('.message-link').show();
            let url = typeof clearFilterUrl !== 'undefined' ? clearFilterUrl : this.paginateUrl + '?page=0';

            //strip out the standard filters since these should not be affected by a filter reset
            let filtersToClear = _.filter(this.filterDefaultVals, function (num) {
                return $('#' + num.id).parents('.tbl-simple-filters').length <= 1;
            }, 0);

            $(filtersToClear).each(function () {
                let $currEl = $('#' + this.id);
                $currEl.val(this.value);
                if ($currEl.is('select')) {
                    $currEl.trigger('change.select2');
                }
            });

            // clear all inputs
            this.$tableSimpleFilters.find('input:not(.unclear)').val('');

            //reset error messages for Date Range
            this.$startDateInput.removeClass('error');
            this.$endDateInput.removeClass('error');
            this.$startDueDateInput.removeClass('error');
            this.$endDueDateInput.removeClass('error');
            this.$dateDueError.hide();
            this.$validDueDateError.hide();
            this.$dateError.hide();
            this.$validDateError.hide();
            this.$('.error-message').hide();

            //reset error messages for Price Range
            this.$priceInputLower.removeClass('error');
            this.$priceInputUpper.removeClass('error');
            this.$priceerror.hide();

            this.$pageSizeInput.val(this.pageSizeDefault);
            this.$pageSizeInput.trigger('change.select2');

            this.$salesOrgValue.val('');
            this.$salesOrgValue.trigger('change.select2');

            $(this.$clearSelectElement).each(function () {
                $(this).val('').trigger('change.select2');
            });

            this.$('.headerLevelClass').prop('checked', false);

            // reset sortCode
            this.sortCode = '';

            this.model.url = url;
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();

            // clear Pikaday
            this.resetPikaday();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();
            this.getClearFilterTableData(e, favorite);
            this.resetSortColumns();

        },

        /**
         * any page (like license listing and download page) which does not call loadjson API with page number, can call this function
         */
        getClearFilterTableData: function (e, favorite) {
            this.model.fetch().done(function (data) {
                if (!_.isUndefined(data.data)) {
                    this.$tableSpinner.hide();
                    this.calculateShowing(data.paginationData);
                    this.calculatePagination(data.paginationData);
                    this.renderRows(data.data);
                    this.$pagination.removeClass('search');
                    this.$sortableColumns.removeClass('asc').removeClass('desc');
                    if (isEcomSite) {
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'clear_filters_quote', '');
                    }

                    if (favorite) {
                        $('#reseller-table').addClass('hide');
                        $('.tbl-simple-page').hide();
                        $('.search-result-header').css('visibility', 'hidden');
                        $('.tbl-simple-header').css('visibility', 'hidden');
                        $('.tbl-simple-footer').css('visibility', 'hidden');
                    }
                }
            }.bind(this)).fail(function () {
                this.tableGenericError();
            }.bind(this));
        },

        /**
         * Get URL variables
         */
        getUrlVars: function () {
            var vars = [];
            var hash;
            var urlParts = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            _.each(urlParts, function (part) {
                hash = part.split('=');
                vars[hash[0]] = hash[1];
            });

            return vars;
        },

        /**
         * Initialize pikaday
         */
        initializePikaday: function () {
            var _startDate;
            var _endDate;
            var _this = this;
            this.startPicker = this.$startDateImg.pikaday({

                /**
                 * onSelect callback
                 */
                onSelect: function () {
                    _this.startDate = this.getDate();
                    _this.pikadayUpdateStartDate(_this.startPicker, _this.endPicker, _this.startDate);
                    _this.$startDateInput.val(this.getMoment().format(dateFormat));
                    _this.validateDate('pikaday');
                },

                maxDate: this.disableFutureDate ? new Date() : null
            });

            this.endPicker = this.$endDateImg.pikaday({

                /**
                 * onSelect callback
                 */
                onSelect: function () {
                    _this.endDate = this.getDate();
                    _this.pikadayUpdateEndDate(_this.startPicker, _this.endPicker, _this.endDate);
                    _this.$endDateInput.val(this.getMoment().format(dateFormat));
                    _this.validateDate('pikaday');
                },

                maxDate: this.disableFutureDate ? new Date() : null
            });

            if (this.startPicker.length > 0) {
                _startDate = this.startPicker.data('pikaday').getDate();
            }

            if (this.startPicker.length > 0) {
                _endDate = this.endPicker.data('pikaday').getDate();
            }

            if (_startDate) {
                this.startDate = _startDate;
                this.pikadayUpdateStartDate(this.startPicker, this.endPicker, this.startDate);
            }

            if (_endDate) {
                this.endDate = _endDate;
                this.pikadayUpdateEndDate(this.startPicker, this.endPicker, this.endDate);
            }
        },

        /**
         * Update Pikaday end date
         */
        pikadayUpdateEndDate: function (startPicker, endPicker, endDate) {
            startPicker.pikaday('setEndRange', endDate);
            endPicker.pikaday('setEndRange', endDate);
            if (endDate) {
                startPicker.pikaday('setMaxDate', endDate);
            }
        },

        /**
         * Update Pikaday start date
         */
        pikadayUpdateStartDate: function (startPicker, endPicker, startDate) {
            startPicker.pikaday('setStartRange', startDate);
            endPicker.pikaday('setStartRange', startDate);
            endPicker.pikaday('setMinDate', startDate);
        },

        /**
         * Reset all pikaday instances
         */
        resetPikaday: function () {
            this.startDate = this.disableFutureDate ? new Date() : this.startDate;
            this.endDate = this.disableFutureDate ? new Date() : null;

            this.startDueDate = this.disableFutureDate ? new Date() : this.startDueDate;
            this.endDueDate = this.disableFutureDate ? new Date() : null;

            this.pikadayUpdateEndDate(this.startPicker, this.endPicker, this.endDate);
            this.pikadayUpdateStartDate(this.startPicker, this.endPicker, this.startDate);

            //go to today's date
            this.startPicker.pikaday('gotoToday');
            this.endPicker.pikaday('gotoToday');

            //reset current date
            this.startPicker.pikaday('setDate', null);
            this.endPicker.pikaday('setDate', null);

            //pikaday only allows passing a value to this method, so resetting the min date to an absurd value
            this.endPicker.pikaday('setMinDate', new Date('1800-01-01'));

            if (this.startDuePicker &&  this.endDuePicker) {
                this.pikadayUpdateEndDate(this.startDuePicker, this.endDuePicker, this.endDueDate);
                this.pikadayUpdateStartDate(this.startDuePicker, this.endDuePicker, this.startDueDate);

                //go to today's date
                this.startDuePicker.pikaday('gotoToday');
                this.endDuePicker.pikaday('gotoToday');

                //reset current date
                this.startDuePicker.pikaday('setDate', null);
                this.endDuePicker.pikaday('setDate', null);

                //pikaday only allows passing a value to this method, so resetting the min date to an absurd value
                this.endDuePicker.pikaday('setMinDate', new Date('1800-01-01'));
            }
        },

        /**
         * Toggle ClearSearch button
         * @param {*} request
         */
        handleClearSearch: function (request) {
            var searchCount = 0;

            _.each(this.$tableSimpleFilters.find('input[type="text"], select, select.tbl-criteria, input:checked'), function ($field) {
                if ($($field).val() && request.searchProperty !== $($field).val() && $($field).val() !== request.pageSize) {
                    searchCount++;
                }
            });

            if (searchCount === 0) {
                this.showClearFilterButton = false;
            }
        },

        /**
         * Select All
         * @param {Object} e
         */
        selectAll: function (e) {
            var checkboxes = this.$table.find('.checkbox').find('input');
            _.each(checkboxes, function (checkbox) {
                $(checkbox).prop('checked', $(e.currentTarget).prop('checked'));
            });
        },

        /**
         * Handle packing slip number click and trigger analytics event
         *
         */
        handlePackingSlipButtonEvent: function () {
            this.gtmEventTracking(this.GTM_EVENT_PACKING_SLIP_CATEGORY, this.GTM_EVENT_ACTION_CARRIER_TRACKING);
            _satellite.track('event:order:clickPackingSlips');
        },

        /**
         * Handle packing slip pdf click and trigger analytics event
         *
         */
        handlePackingSlipButtonPdfEvent: function () {
            this.gtmEventTracking(this.GTM_EVENT_PACKING_SLIP_CATEGORY, this.GTM_EVENT_ACTION_PDF_CARRIER_TRACKING);
        },

        /**
         * Select table checkbox and enable button
         * */
        selectCheckBoxRfq: function (e) {
            let checkboxes = this.$table.find('.rfQcheckBox');
            let anyChecked = $(checkboxes).is(':checked');
            let arrayForCheckBoxes = [];
            if ($('.hasCloseRFQ').is(':visible')) {
                $('.closeRfqBtn').prop('disabled', !anyChecked);
            } else {
                $('.reOpenRfqButton').prop('disabled', !anyChecked);
            }

            _.each(checkboxes, function (checkbox) {
                arrayForCheckBoxes.push ($(checkbox).prop('checked'));
            });

            let ifAllTrue = arrayForCheckBoxes.every(v => v === true);
            if (ifAllTrue) {
                $('#select-all-checkbox-rfq').prop('checked', true);
            } else {
                $('#select-all-checkbox-rfq').prop('checked', false);
            }
        },

        selectAllRfqCheckboxes: function (e) {
            let checkboxes = this.$table.find('.rfQcheckBox');
            let isCheckedAllRfq = $(e.target).is(':checked');
            if (isCheckedAllRfq) {
                if ($('.hasCloseRFQ').is(':visible')) {
                    $('.closeRfqBtn').prop('disabled', false);
                    $('.reOpenRfqButton').prop('disabled', true);
                } else {
                    $('.closeRfqBtn').prop('disabled', true);
                    $('.reOpenRfqButton').prop('disabled', false);
                }
            } else {
                $('.closeRfqBtn').prop('disabled', true);
                $('.reOpenRfqButton').prop('disabled', true);
            }

            _.each(checkboxes, function (checkbox) {
                if (!$(checkbox).prop('disabled')) {
                    $(checkbox).prop('checked', $(e.currentTarget).prop('checked'));
                }

            });

        },

        closeRfqFn: function (e) {
            let checkedRowsData = [];
            let table = $('#rfq-table').DataTable();
            $('.rfQcheckBox:checked').each(function(i, v) {
                var rowData = $(v).closest('tr').find('.rfqIds').text().trim();
                checkedRowsData.push(rowData);
            });

            let req = {
                closeRFQ: $(e.currentTarget).hasClass('hasCloseRFQ') ? true : false,
                rfqIds: checkedRowsData
            };

            $.ajax({
                url: globals.path.api.quoting.closeOrReopenRFQ + '?closeRFQ=' + req.closeRFQ + '&rfqIds=' + req.rfqIds.join(',') + '&' + CSRF,
                type: 'POST',
                contentType: 'application/json',
                success: (response) => {
                    if (response) {
                        this.$table.find('.rfQcheckBox').prop('checked', false);
                        $('.closeRfqBtn').prop('disabled', true);
                        $('#select-all-checkbox-rfq').prop('checked', false);
                        this.searchFilter(e);
                    }
                },

                fail: function(response) {
                    globals.enableApp();
                    console.error(response);
                }
            });
            console.log(req);
        }
    });

    ws.views.simpleTableRows = Backbone.View.extend({
        tagName: 'tr',

        /**
         * Initialize function
         */
        initialize: function (options) {
            this.template = _.template(options.rowTemplate.html());
            this.render();
        },

        /**
         * Render function]
         */
        render: function () {
            this.$el.html(this.template(this.model));
            return this;
        }

    });

    ws.views.simpleTableQuickView = Backbone.View.extend({
        tagName: 'tbody',

        /**
         * Initialize function
         */
        initialize: function (options) {
            this.template = _.template(options.rowTemplate.html());
            this.render();
        },

        /**
         * Render function
         */
        render: function () {
            this.$el.html(this.template({collection: this.collection}));
            return this;
        }
    });

})(westcon, window);
